import React from 'react';
import Loader from '../components/loader';
import HeroHeader from '../components/HeroHeader';
import SubCourseComponent from '../components/sub-course-page';

class SubCourse extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, 100); // Simulate a 3-second loading delay
  }


  render() {
    const teamData = [
      {
        image: "img/team-1.jpg",
        name: "Anamul Hasan",
        role: "President",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        socialLinks: [
          { icon: "fab fa-facebook-f", url: "#" },
          { icon: "fab fa-twitter", url: "#" },
          { icon: "fab fa-instagram", url: "#" },
          { icon: "fab fa-linkedin-in", url: "#" },
        ],
        sizeLg: 4,
        sizeXl: 5
      },
      {
        image: "img/team-2.jpg",
        name: "Mustafa Kamal",
        role: "Imam",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        socialLinks: [
          { icon: "fab fa-facebook-f", url: "#" },
          { icon: "fab fa-twitter", url: "#" },
          { icon: "fab fa-instagram", url: "#" },
          { icon: "fab fa-linkedin-in", url: "#" },
        ],
        sizeLg: 4,
        sizeXl: 4
      },
      {
        image: "img/team-3.jpg",
        name: "Nahiyan Momen",
        role: "Teacher",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        socialLinks: [
          { icon: "fab fa-facebook-f", url: "#" },
          { icon: "fab fa-twitter", url: "#" },
          { icon: "fab fa-instagram", url: "#" },
          { icon: "fab fa-linkedin-in", url: "#" },
        ],
        sizeLg: 4,
        sizeXl: 4
      },
      {
        image: "img/team-4.jpg",
        name: "Asfaque Ali",
        role: "Volunteer",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        socialLinks: [
          { icon: "fab fa-facebook-f", url: "#" },
          { icon: "fab fa-twitter", url: "#" },
          { icon: "fab fa-instagram", url: "#" },
          { icon: "fab fa-linkedin-in", url: "#" },
        ],
        sizeLg: 4,
        sizeXl: 4
      }
    ];
    const breadcrumbs = [
        { label: 'Home', href: '/home', isCurrentPage: false },
        { label: 'Our Courses', href: '#', isCurrentPage: true },
      ];

    return <>
      {this.state.loading ? <Loader /> :
        <>
          <HeroHeader  title="Our Course" breadcrumbs={breadcrumbs} />
          <SubCourseComponent teamData={teamData}/>
        </>}
    </>
  }
}

export default SubCourse;
